import { OrderList, OrderShow } from 'pages/sales/orders';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'orders',
  label: 'Pedidos realizados',
  list: OrderList,
  show: OrderShow,
  actions: ['list', 'show', 'magic_link'],
  parentName: 'sales'
};

export default generateResources(resource);
